import React from "react"
import { graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Careers from "../components/careers"
import ListTitle from "../components/listTitle"

const careers = [
  {
    company: "수퍼트리",
    position: "프론트엔드 개발자",
    start: "2020.04",
    projects: [
      {
        title: "C2C 마켓 플레이스",
        site: "https://market.playdapp.com/",
        start: "2020.04",
        end: "",
        description: [
          "Javascript, ReactJs를 사용하여 SPA 개발",
          "Redux, Redux-thunk를 이용한 동기/비동기 상태 관리",
          "시맨틱 마크업 및 BEM 방법론 기반의 CSS 코드 작성",
          "react-bootstrap과 SCSS를 활용하여 반응형 사이트 개발",
          "gulp와 git pre-commit hook을 사용하여 커밋 전 이미지 압축 기능 개발",
          "코드 스프리팅을 적용하여 사이트 최적화",
          "bignumber.js 활용하여 큰 수 처리",
        ],
        skills: [
          "reactJS",
          "redux",
          "redux-thunk",
          "Javascript",
          "HTML5",
          "SCSS",
          "react-bootstrap",
          "Algolia",
          "web3.js",
        ],
      },
      {
        title: "C2C 마켓 플레이스 스토어프론트",
        start: "2020.10",
        end: "2020.11",
        description: [
          "게임 개발사가 마켓에 입점 할 수 있도록 서비스 개발",
          "Typescript, ReactJs를 사용하여 SPA 개발",
          "EmotionJs 라이브러리를 이용하여 CSS-in-JS 기반으로 컴포넌트 개발",
          "React-hook-form 라이브러리를 사용하여 폼 개발",
          "이미지 파일 추가 및 미리보기 기능 개발",
        ],
        skills: [
          "Typescript",
          "reactJS",
          "redux",
          "redux-thunk",
          "emotionJS",
          "react-hook-form",
        ],
      },
    ],
  },
  {
    company: "와이비엠넷",
    position: "ASP 웹 개발자",
    start: "2017.01",
    end: "2019.04",
    projects: [
      {
        title: "YBM 이러닝 B2C 사이트 개발 및 운영",
        site: "http://toeic.ybmclass.com/",
        start: "2017.01",
        end: "2019.04",
        description: [
          "HTML5, CSS, jQuery를 사용하여 프로모션 페이지 개발",
          "ASP, MS-SQL을 사용하여 사이트 개발",
          "IE 브라우저 대응",
          "MS-SQL 프로시저 속도 개선 및 마케팅 통계 자료 추출",
          "반복되는 작업 요청 자동화 - 컨텐츠 이미지가 들어간 HTML을 생성하여 URL 제공하는 작업",
        ],
        skills: ["ASP", "MSSQL", "HTML", "CSS", "jQuery", "Jenkins", "Redmine"],
      },
    ],
  },
]

const AboutIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="이력서" />
      <Bio />
      <ListTitle>업무 경험</ListTitle>
      <Careers careers={careers} />
    </Layout>
  )
}

export default AboutIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
